
import { getProjectData } from '@/apps/unrealos/views/projects/data';
import View from '@/apps/unrealos/views/projects/detail';
import { getCustomServerSideProps, GetServerSidePropsContext } from '@/utils/serverSide';

export default View;

export const getServerSideProps = async (
    context: GetServerSidePropsContext,
) => {

    const slug = context.params?.slug as string;
    const projectData = getProjectData(slug);

    /**
     * Redirect to projects page if project is unknown
     */
    let redirect: { destination: string; permanent: boolean } | undefined;
    if (projectData.slug === 'unknown') {
        redirect = {
            destination: '/projects',
            permanent: false,
        };
    }

    return getCustomServerSideProps(
        context,
        {
            slug,
            config: {
                layout: {
                    name: 'unrealos',
                },
                protected: false,
            },
        },
        {
            redirect,
            redirectIfLogged: false,
            seoConfig: {
                title: projectData.title,
                description: projectData.description,
            },
        },
    );
};
